module.exports = __webpack_public_path__ + "img/[烟花].44ebec9c.svg";